const initialProducts = [
  { key: -1, label: 'Select All', color: 'default', id: 'Select All', isSelectAll: true },
  { key: 0, label: 'Console', color: 'primary', id: 'Console' },
  { key: 1, label: 'DeepCall', color: 'error', id: 'DeepCall' },
  { key: 2, label: 'Sarv.com', color: 'primary', id: 'Sarv.com' },
  { key: 3, label: 'Meet', color: 'success', id: 'Meet' },
  { key: 4, label: 'DeepEnrich', color: 'primary', id: 'In.inc' },
  { key: 5, label: 'Naam', color: 'primary', id: 'Naam.ai' },
];

module.exports = { initialProducts };
